import styled from 'styled-components';

import {
  ICompactComponent,
} from 'src/pages/CatalogPage/components/AuctionItems/AuctionItem/AuctionItem.style';
import { BoxButton, TextButton } from '@riac/design-system';

import { IItemActionIcon } from 'src/pages/CatalogPage/components/AuctionItems/AuctionItem/AuctionItemActions.i';
import { LoginToUseContainer } from 'src/components/LoginToUse/LoginToUse';
import { PlaceBidButton } from 'src/components/PlaceBid/PlaceBid.style';

export const ItemActionIcon = styled.span<IItemActionIcon>`
  font-size: 2.2rem;
  margin-right: ${(props) => (props.marginRight ? props.marginRight : '5px')};
  color: ${(props) => (props.active ? props.theme.gold[50] : props.theme.black[60])};
  svg {
    transform: translateY(5px);
  }
`;

export const SecondaryItemActionLabel = styled.label`
  display: flex;
  align-items: center;
  cursor: pointer;
  color: ${(props) => props.theme.black[50]};

  width: 250px;
  max-width: 100%;

  & {
    font-size: 2rem;
    border: 1px solid transparent;
    &:hover {
      border: 1px solid transparent;
    }
    &:focus {
      border: 1px solid transparent;
    }
  }
`;

export const BidButtons = styled.div``;

export const WishlistAndText = styled.div`
  margin: 0 5px;
  display: flex;
  flex-direction: column;
`;

export const Actions = styled.div<ICompactComponent>`
  position: relative;
  display: grid;
  grid-template-rows: 1fr auto;
  grid-template-columns: auto 1fr;
  grid-gap: 10px;
  
  ${BidButtons} {
    grid-area: 2 / 1 / 3 / 3;
    ${(props) => props.theme.tablet} {
      grid-area: ${(props) => (props.compact ? '1 / 1 / 3 / 2' : '1 / 1 / 2 / 3')};
    }
  }
  ${WishlistAndText} {
    grid-area: 1 / 1 / 2 / 3;
    ${(props) => props.theme.tablet} {
      grid-area: ${(props) => (props.compact ? '1 / 2 / 3 / 3' : '2 / 1 / 3 / 3')};
    }
  }
  ${SecondaryItemActionLabel} {
    ${(props) => (props.compact ? 'width: auto;' : '')}
  }
`;

export const BidSubmittedButton = styled(TextButton)`
  font-size: 1.6rem;
  text-decoration: none;
  color: ${(props) => props.theme.black[50]};
  margin-left: 4px;
`;

export const TimedAuctionItemInfo = styled.div`
  font-size: 1.6rem;
  color: ${(props) => props.theme.black[70]};
    margin: 0 5px;
`;

export const ActionButtons = styled(BoxButton)`
  margin: 1rem 0;
  color: ${(props) => props.theme.black[70]};
  background-color: ${(props) => props.theme.black[20]};
  display: block;
  padding: revert;
`;

export const WishlistCount = styled.span`
  color: ${(props) => props.theme.black[70]};
  font-size: initial;
`;
